{
  "empty": "Use at least {min} characters.",
  "levels": {
    "too_short": "Too short.",
    "weak": "Weak",
    "good": "Good",
    "strong": "Strong"
  },
  "missing": "Add {count} more {count, plural, =1 {character} other {characters}}."
}
